module.exports = __webpack_public_path__ + "static/media/vision-01.c6d021e0.jpg";